<template>
    <v-sheet>
        <template v-if="items?.length">
            <v-data-table v-bind="{ items, headers }" disable-filtering disable-pagination disable-sort hide-default-footer :mobile-breakpoint="$vuetify.breakpoint.thresholds.sm">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
            </v-data-table>
            <v-pagination v-model="page" :length="pageCount" total-visible="11" color="primary" @input="search" />
        </template>
        <template v-else>
            <p class="page-text grey-6--text text-center">
                안녕하세요, 담당자님. <br />
                신용카드 거래 내역이 없습니다.
            </p>
        </template>
    </v-sheet>
</template>

<script>
import api from "@/api";

const headers = [
    { width: 164, text: "주문일시", value: "createdAt", formatter: (value) => value?.toDateTime?.() || value || "-" },
    { width: 160, text: "주문번호", value: "orderNo" },
    { width: 120, text: "결제수단", value: "paymentMethod" },
    { width: 120, text: "결제금액", value: "paymentAmount", formatter: (value) => (value?.format?.() || 0) + "원" },
    { width: 120, text: "상태", value: "stateText" },
    { width: 120, text: "비고", value: "orderName" },
].map((item) => ({ ...item, formatter: item.formatter ?? ((value) => value ?? "-") }));

export default {
    data: () => ({
        orders: [],

        page: 1,
        limit: 10,
        summary: { totalCount: 0 },

        headers,

        loading: false,
    }),
    computed: {
        items() {
            return [...this.orders];
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            return {};
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { skip, limit, params } = this;
                const { summary, orders } = await api.v1.me.points.orders.gets({
                    headers: { skip, limit },
                    params,
                });

                this.orders = orders;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }
}
</style>